import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  DEFAULT_STATUS_FILTER,
  type StatusFilterOption,
} from "@/constants/sparxsCatalogFilters";
import { clearSparxsCatalogFiltersToDefaults } from "@/store/statistics/sparxsCatalogFiltersActions";

const statusFilterSlice = createSlice({
  name: "statusFilter",
  initialState: DEFAULT_STATUS_FILTER,
  reducers: {
    updateStatus: (_, action: PayloadAction<StatusFilterOption>) =>
      action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(
      clearSparxsCatalogFiltersToDefaults,
      () => DEFAULT_STATUS_FILTER,
    );
  },
});

export const { updateStatus } = statusFilterSlice.actions;
export default statusFilterSlice.reducer;
